import { useNavigate } from "react-router-dom";
import { Anchor, User, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";

const Header = ({ token, onSignOut, onShowAuth }) => {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 h-16 flex items-center justify-between px-4 border-b border-border/40 backdrop-blur-lg bg-background/80">

      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={() => navigate("/")}
      >
        <Anchor className="w-6 h-6 text-primary" />
        <span className="text-xl font-bold">
          MarineKnow
        </span>
      </div>

      <div className="flex items-center gap-4">

        <button
          onClick={() => navigate("/about")}
          className="text-sm text-muted-foreground hover:text-primary"
        >
          About
        </button>

        <button
          onClick={() => navigate("/contact")}
          className="text-sm text-muted-foreground hover:text-primary"
        >
          Contact
        </button>

        {token ? (
          <>
            <Button
              variant="ghost"
              size="sm"
              className="rounded-full"
              onClick={() => navigate("/profile")}
            >
              <User className="w-4 h-4 mr-1" />
              Profile
            </Button>

            <Button
              variant="ghost"
              size="sm"
              className="rounded-full"
              onClick={onSignOut}
            >
              Sign Out
            </Button>
          </>
        ) : (
          <Button
            variant="ghost"
            size="sm"
            className="rounded-full"
            onClick={onShowAuth}
          >
            <LogIn className="w-4 h-4 mr-1" />
            Sign In
          </Button>
        )}

      </div>

    </header>
  );
};

export default Header;
